import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../layout/Layout';
import ServiceLayout from '../components/ServiceLayout';

export default function Devops() {
  return (
    <Layout>
      <ServiceLayout
        title="DevOps"
        banner="/assets/images/banner/devopss.jpg"
        current="/devops"
      >
        <div className="space-y-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-brand-dark mb-4">DevOps</h2>
            <p className="text-gray-600 leading-relaxed mb-3">
              At our DevOps Service Hub, we're dedicated to streamlining your development operations, enabling you to deliver high-quality software faster and more efficiently than ever before. Our comprehensive suite of DevOps services encompasses everything from continuous integration and delivery (CI/CD) to infrastructure automation and cloud management.
            </p>
            <p className="text-gray-600 leading-relaxed mb-3">
              With a focus on collaboration and automation, we help you break down silos between development and operations teams, fostering a culture of efficiency and innovation.
            </p>
            <h3 className="text-lg font-bold font-heading text-brand-dark mb-2">Our DevOps Approach</h3>
            <p className="text-gray-600 leading-relaxed mb-4">
              At the heart of our approach to DevOps is a focus on breaking down silos between development and operations teams, fostering a culture of collaboration, communication, and continuous improvement.
            </p>
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3 list-none p-0">
              {['Sustainable Working', 'New Methodologies'].map((item) => (
                <li key={item} className="flex items-center gap-3 text-brand-dark/80 text-sm">
                  <span className="flex-shrink-0 w-6 h-6 rounded-full bg-brand/10 flex items-center justify-center">
                    <span className="icon-check-circle text-brand text-xs"></span>
                  </span>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          <img src="devpos.webp" alt="#" className="w-full rounded-2xl shadow-md" />

          <div>
            <p className="text-gray-600 leading-relaxed mb-6">
              Our team of experienced DevOps engineers is committed to understanding your unique requirements and designing tailored solutions that align with your business objectives.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {[
                { icon: 'icon-web-design', title: 'Infrastructure as Code (IaC)', desc: 'We leverage tools such as Terraform, Ansible, and Chef to automate the provisioning and management of infrastructure, enabling organizations to deploy and scale resources with ease.' },
                { icon: 'icon-data', title: 'CI/CD Pipelines', desc: 'We implement CI/CD pipelines using industry-leading tools like Jenkins, GitLab CI/CD, and CircleCI to automate the build and deployment processes, reducing manual errors.' },
              ].map(({ icon, title, desc }) => (
                <div key={title} className="flex items-start gap-4 bg-gray-50 rounded-xl p-5 border border-gray-100">
                  <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-brand flex items-center justify-center">
                    <span className={`${icon} text-white text-xl`}></span>
                  </div>
                  <div>
                    <h3 className="text-brand-dark font-bold font-heading mb-2">{title}</h3>
                    <p className="text-gray-500 text-sm leading-relaxed">{desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="flex flex-col md:flex-row gap-6 items-start">
            <div className="flex-1">
              <p className="text-gray-600 leading-relaxed mb-4">
                By fostering collaboration, automation and continuous improvement, DevOps can propel your development process into the high-velocity world of modern software development.
              </p>
              <ul className="space-y-2 list-none p-0">
                {[
                  'Powerful approach to software development that can empower your team to deliver high-quality.',
                  'Higher quality software delivery through automation & collaboration.',
                  'DevOps bridges dev & ops for faster delivery.',
                ].map((item) => (
                  <li key={item} className="flex items-start gap-2 text-gray-600 text-sm">
                    <span className="icon-tick text-brand flex-shrink-0 mt-0.5"></span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
            <div className="flex-shrink-0 md:w-48">
              <img src="/assets/images/services/img2.png" alt="#" className="w-full rounded-xl shadow-sm" />
            </div>
          </div>
        </div>
      </ServiceLayout>
    </Layout>
  );
}
